import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { DefaultEditor} from 'ng2-smart-table';
import {ApiService} from '../../../../@core/service/api.service';

const MAX_INSTANCES = 60;

@Component({
  template: `
    <ngx-form-date [value]="cell.newValue" (valueChange)="onValueChange($event)"></ngx-form-date>
  `,
})
export class FormListDateEditComponent extends DefaultEditor implements AfterViewInit {

  static instances: FormListDateEditComponent[] = [];

  constructor(
    private api: ApiService,
  ) {
    super();
  }

  ngAfterViewInit() {
    FormListDateEditComponent.instances.push(this);
    if (FormListDateEditComponent.instances.length > MAX_INSTANCES) {
      FormListDateEditComponent.instances.splice(0, 1);
    }
  }

  onValueChange(value) {
    const oldValue = this.cell.getValue()
    this.cell.setValue(value);
    const instances = FormListDateEditComponent.instances;
    const instance = FormListDateEditComponent.instances.find(f => f === this);
    this.cell.getColumn().editor.config?.callback(instances, instance, oldValue, value);
  }

  count = 0;
  syncValues() {
    for (let i = 0; i < FormListDateEditComponent.instances.length; i++) {
      const inst = FormListDateEditComponent.instances;
      const val = this.cell.newValue;
      // const re = /(\w)\-([\d.,]+)?\-?([\d.,]+)?\-?([RGTC]+)?.*/;
      if (inst[i] === this) {
        switch (this.cell.getColumn().id) {
          case 'validFrom':
            const validTo = inst[i+1];
            console.log(
              'valid from changed', 
              inst, 
              val,
              this.cell.getColumn().editor.config,
              this.cell.getColumn().editor
            )
            // if (val.match(/[\w]+/)) {
            //   let name = inst[i-3].text.nativeElement.value;
            //   name = name.replace(re, '$1-$2-$3-' + val);
            //   inst[i-3].text.nativeElement.value = name;
            //   inst[i-3].cell.newValue = name;
            // }
            break;
        }
      }
    }
  }

}
